// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071704/js/" + chunkId + "." + {"44":"471f06c5","225":"cd5fa3d7","481":"892731ac","486":"b0819d6e","770":"5ced18aa"}[chunkId] + ".0.4329371035193387.chunk.js";
};